var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2083_56723)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31773 3.60063C9.44949 3.23525 9.74312 3 10.0685 3H16.5568C17.1668 3 17.5645 3.79083 17.2912 4.46354L15.4457 9.00633H18.177C18.9091 9.00633 19.2751 10.0955 18.7578 10.7321L9.03549 22.6977C8.4222 23.4525 7.4006 22.6757 7.67552 21.6637L9.748 14.0116H6.82148C6.68462 14.0116 6.54994 13.9695 6.42966 13.8892C6.30937 13.8088 6.2073 13.6928 6.13272 13.5516C6.05814 13.4103 6.0134 13.2484 6.00257 13.0805C5.99175 12.9126 6.01518 12.744 6.07073 12.5901L9.31773 3.60063Z",
    fill: "#FFC977"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2083_56723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostIcon);
export default __webpack_public_path__ + "static/media/boost_icon.0211c18e5ba55ffa29c416de54506235.svg";
export { ForwardRef as ReactComponent };